<template>
    <div>
      <div class="modal right fade" id="categorySideBar">
        <div class="modal-dialog">
          <div class="d-flex align-content-center justify-content-end">
            <button type="button" class="btn-close p-3" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-content border-0">
            <div class="modal-body p-0">
              <ul class="small__nav p-0">
                  <template v-for="(item , id) in menu" :key="id">
                      <li class="nav-item">
                          <a class="nav-link" aria-current="page" :href="item">{{ id }}</a>
                      </li>
                  </template>

              </ul>
            </div>
          </div>
        </div>
      </div>

        <MainMenuResponsive />
        <!--end-small-nav-->
        <div class="container-fluid p-0 m-0">
            <div class="background__index d-flex fruitLarge flex-column align-content-center justify-content-center">
                <!--navBar-->
              <nav class="navbar navbar-expand-lg navbar-dark py-5 ps-0 fixed-top" id="navbar">
                <div class="container bg-nav py-2">
                  <button class="navbar-toggler px-3 py-3 text-white" data-bs-toggle="modal"
                          data-bs-target="#categorySideBar">
                    <img width="24" src="/front/assets/images/menu.png" alt="">
                  </button>
                  <div class="d-flex align-content-center">
                    <div class="ps-4 d-block d-lg-none my-auto">
                      <p class="text-md text-white m-0 line-height" style="direction: ltr">
                          <img width="20" src="/front/assets/images/call.png" alt="">
                          <span class="d-inline-block" style="margin-left: 10px" v-text="data.supportPhone"></span>
                      </p>
                    </div>
                    <a class="pe-2 me-auto" :href="data.url">
                      <img src="/front/assets/images/badoom-03.png" alt="">
                    </a>
                  </div>

                  <div class="collapse navbar-collapse" id="navbarNav">
                    <ul class="navbar-nav">
                        <template v-for="(item , id) in menu" :key="id">
                            <li class="nav-item">
                                <a class="nav-link active" aria-current="page" :href="item">{{ id }}</a>
                            </li>
                        </template>


                    </ul>
                  </div>
                  <div class="ps-3 d-none d-lg-block">
                    <p class="text-md text-white ms-auto m-0" style="direction: ltr">
                        <img width="20" src="/front/assets/images/call.png" alt="">
                        <span class="d-inline-block" style="margin-left: 10px" v-text="data.supportPhone"></span>
                    </p>
                  </div>
                </div>
              </nav>

              <!--end-navBar-->

                <slot />
            </div>
        </div>


    </div>
</template>

<script>


import MainMenuResponsive from "./../Menus/MainMenuResponsive";
import FirstRegisterMenu from "../Menus/FirstRegisterMenu";
export default {

    components : {MainMenuResponsive , FirstRegisterMenu },
    props: {
        data : Object,
        auth: Object,
        menu: Object,
    },


}
</script>

<style scoped>

</style>
